// extracted by mini-css-extract-plugin
export default {"tagContainer":"Tag-module__tagContainer","tag-blue":"Tag-module__tag-blue"};